import { ConnectedAccountSettings, ExpenseApprovals, ExpenseCategories } from '@/views/AccountSettings'

const AccountSettingsPage: React.FC = () => {
  return (
    <div>
      <ExpenseApprovals />
      <ExpenseCategories />
      <ConnectedAccountSettings />
    </div>
  )
}

export default AccountSettingsPage
